__turbopack_context__.v({
  "dataContainer": "styles-module-scss-module__abPySG__dataContainer",
  "earnValue": "styles-module-scss-module__abPySG__earnValue",
  "earnValueSC": "styles-module-scss-module__abPySG__earnValueSC",
  "root": "styles-module-scss-module__abPySG__root",
  "rootDarkMode": "styles-module-scss-module__abPySG__rootDarkMode",
  "title": "styles-module-scss-module__abPySG__title",
  "titleDarkMode": "styles-module-scss-module__abPySG__titleDarkMode",
});
